/**
 * @file 后台顶栏右侧操作区
 * @description 主题入口 + 用户菜单的组合。
 *
 * @whenToUse AdminShell 顶栏右侧默认内容。
 * @whenNotToUse 业务页内工具栏操作（用 Button / IconButton 自行组合）。
 */

import { AdminUserMenu } from '@/components/admin-user-menu.tsx'
import { ThemeSwitcherDialog } from '@/components/theme-switcher-dialog.tsx'

export type AdminTopbarActionsProps = {
  /** 当前登录用户名 */
  username: string
  /** 头像图片地址；透传给用户菜单 */
  avatarSrc?: string
}

/**
 * 顶栏右侧：主题切换弹窗 + 用户菜单。
 */
export function AdminTopbarActions({
  username,
  avatarSrc,
}: AdminTopbarActionsProps) {
  return (
    <>
      <div className="text-sm inline-flex items-center">点数：<span className="text-primary font-medium">100</span></div>
      <ThemeSwitcherDialog />
      <AdminUserMenu username={username} avatarSrc={avatarSrc} />
    </>
  )
}
